import { render, staticRenderFns } from "./RegistroInvitadoAdmin.vue?vue&type=template&id=0cfbf46b&"
import script from "./RegistroInvitadoAdmin.vue?vue&type=script&lang=js&"
export * from "./RegistroInvitadoAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports